import { IconX } from "@tabler/icons-react";
import { ReactNode } from "react";

type Props = {
  open: boolean;
  onClose: () => void;
  pickupLocationItem?: any;
};

const InfoRow = ({ label, value }: { label: string; value: ReactNode }) => (
  <div className="flex justify-between items-center w-full">
    <div className="w-full">
      <h2 className="capitalize text-[#212121] text-sm font-medium">{label}</h2>
    </div>
    <div className="w-full text-end">
      {typeof value === "string" ? (
        <p className="text-[#1E293B] text-base">{value}</p>
      ) : (
        value
      )}
    </div>
  </div>
);

const LocationViewModal = ({ open, onClose, pickupLocationItem }: Props) => {
  if (!open) return null;

  return (
    <>
      <div className="fixed top-0 left-0 w-full h-screen  bg-black/60 z-50 flex items-center justify-end p-4">
        <div className="rounded-2xl w-4/12 relative">
          <div className="flex items-center">
            <div className=" bg-gradient-to-tr from-[#FDF8E5] to-[#FAF8EC] flex items-center justify-between px-6 py-4   w-full rounded-tl-3xl rounded-tr-[63px] ">
              <h1 className="text-2xl">View Pickup Location</h1>
            </div>
            <div className="relative ">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width={38}
                height={37}
                viewBox="0 0 38 37"
                fill="none"
                className="absolute -bottom-[10px] -left-[8px] rotate-[-1.8deg]"
              >
                <path
                  d="M0.5 0L4.86189 10.5496C10.4737 24.1222 22.9306 33.645 37.5 35.5L4.91509 37L0.5 0Z"
                  fill="#F7F6F2"
                />
              </svg>

              <button
                onClick={onClose}
                className="bg-[#F2F2F7] rounded-full p-1 cursor-pointer w-12 h-12 ml-5 flex items-center justify-center flex-shrink-0"
              >
                <IconX size={20} />
              </button>
            </div>
          </div>
          <div className="w-full py-4 px-6 space-y-4 bg-gradient-to-tr from-[#FDF8E5] to-[#FAF8EC] rounded-tr-[30px]">
            <div className="overflow-y-auto space-y-4 border-[1.5px] border-[#D2D2D2] p-2 rounded-lg">
              <p className="text-[#212121]/80 col-span-6 uppercase text-sm font-medium">
                Details
              </p>
              <InfoRow label="Pickup iD" value={pickupLocationItem?.pickupId} />
              <InfoRow
                label="Pickup Address"
                value={pickupLocationItem?.fullAddress}
              />
              <InfoRow label="Country" value={pickupLocationItem?.country} />

              <InfoRow label="City" value={pickupLocationItem?.city} />
              <InfoRow label="District" value={pickupLocationItem?.district} />
              <InfoRow label="Pincode" value={pickupLocationItem?.pinCode} />
            </div>
          </div>
          <div className="border-t border-[#D8D8D8] px-6 py-6 flex justify-end space-x-2  bg-gradient-to-tr from-[#FDF8E5] to-[#FAF8EC] rounded-b-[30px] "></div>
        </div>
      </div>
    </>
  );
};

export default LocationViewModal;
